import * as R from 'ramda'
import { ofType } from 'redux-observable'
import { filter, tap, ignoreElements } from 'rxjs/operators'
import { hasStorage } from 'helpers/LocalStorageHelper'
import * as Actions from 'store/actions/index.ts'

const configuratorSelectionChangeEpic = (actions$, state$) => actions$.pipe(
  ofType(Actions.configurator.CONFIGURATOR_SELECTION_CHANGE),
  filter(action => hasStorage && !action.payload.isAutoSelect),
  tap(({ payload: { selection } }) => {
    R.mapObjIndexed((value, key) => {
      localStorage.setItem(`configurator-${key}`, JSON.stringify(value))
    })(selection)
  }),
  ignoreElements()
)

export default configuratorSelectionChangeEpic
